<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="userProfilePicture">
    <ngx-avatar
        [round]="round"
        [size]="size"
        [bgColor]="bgColor"
        [fgColor]="fgColor"
        initialsSize="1"
        [src]="url"
        [name]="DisplayName"
        textSizeRatio="2.5"
        [borderColor]="borderColor"
    >
    </ngx-avatar>
</div>
